import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ApiService } from '../../service/api_service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../components/auth/auth.service';

@Component({
  selector: 'app-addbanner',
  template: require('./addbanner.component.html'),
  // styles: [require('./addbanner.component.css')],
})
export class AddBannerComponent implements OnInit {
  model: NgbDateStruct;
  Banner: any = [];
  displayedImage;
  busy: Subscription;
  uploadedImage;
  token: any;
  f_chkString(p_value) {
    var Val = (p_value ? p_value.toString() : "").trim();
    return Val;
  }

  f_ChkNum(p_value) {
    var Num = Number(p_value);
    if (Num) {
      return Num;
    }
    return 0;
  }
  static parameters = [ApiService, ActivatedRoute, Router, HttpClient, ToastrService, AuthService]
  constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute, private router: Router, private http: HttpClient, private toastr: ToastrService, private authService: AuthService) {
    this.apiService = apiService;
  }

  ngOnInit() {
    this.token = JSON.parse(sessionStorage.getItem("currentUser"));
    this.displayedImage = 'assets/images/home-image.jpg';
    this.InitBanner();
    this.activatedRoute.queryParams.subscribe(params => {
      var _ID = Number(params['id']) ? Number(params['id']) : 0;
      this.Banner.Banners_ID = _ID;
      this.GetBannerDetailsByID(_ID);
    });
  }
  InitBanner() {
    //this.displayedImage = 'Screenshot2021-06-15-16-45-51-6823b6155b0859d87d8a0f743b8170eb9d_20217814103058.jpg';//'assets/images/home-image.jpg';
    this.Banner = {};
    this.Banner.Banners_ID = 0;
    this.Banner.BannerApplicable = "0";
    this.Banner.IsActive = true;
  
  }



  formData = new FormData();
  onFileSelected(event) {
    this.uploadedImage = event.target.files[0];
    if (this.uploadedImage.type == "image/jpeg" || this.uploadedImage.type == "image/png") {
      this.uploadImage();
    }
    else (
      this.toastr.warning('please Upload Jpg/Png File')
      
    )
  }

  uploadImage() {
    // BannerUpload
    if (this.uploadedImage) {
      this.formData.append('image', this.uploadedImage, this.uploadedImage.name)
      console.log(this.formData.getAll('image')) //confirms file is being uploaded properly
      this.busy = this.http.post('/api/admin/BannerImageUpload', this.formData)
        .subscribe(res => {
          console.log('res :', res);
          this.displayedImage = res["path"];
          this.toastr.success('Image Uploaded Succesfullly');
          // this.displayedImage ='file:///D:/Projects/enterofieldforce/public/upload/Banner/Screenshot2021-06-15-16-45-51-6823b6155b0859d87d8a0f743b8170eb9d_202178112531338.jpg'
          // this.displayedImage = res["path"];
        });
    }
  }

  SaveBanner() {
    this.Banner.BannerApplicable = this.f_chkString(this.Banner.BannerApplicable);
    this.Banner.BannerTitle = this.f_chkString(this.Banner.BannerTitle);
    this.Banner.BannerDesc = this.f_chkString(this.Banner.BannerDesc);

    // if (this.Banner.BannerApplicable == 0) {
    //   this.toastr.warning('Please Select Banner Applicable For');
    //   return false;
    // }
    if ((this.Banner.BannerTitle).length == 0) {
      this.toastr.warning('Please Enter Banner Name');
      return false;
    }

    if ((this.Banner.BannerDesc).length == 0) {
      this.toastr.warning('Please Enter Banner Description');
      return false;
    }
    var queryData = {
      BannerApplicable: this.Banner.BannerApplicable,
      BannerTitle: this.Banner.BannerTitle,
      BannerDesc: this.Banner.BannerDesc,
      IsActive: this.Banner.IsActive ? 1 : 0,
      ImgPath: this.displayedImage,
      ID: this.token.id,
      Banners_ID: this.Banner.Banners_ID
    }
    this.busy = this.http.post('/api/admin/SaveBannerDetails', queryData).subscribe((res: any) => {
      console.log('res: ', res);
      if (res.data.length > 0) {
        if (res.data[0].flag == 1) {
          this.toastr.success(res.data[0].msg);
          this.router.navigate(['/banners']);
        }
        else {
          this.toastr.warning(res.data[0].flag)
        }
      }
    })
  }

  GetBannerDetailsByID(id) {
    var data = { "ID": id };
    this.busy = this.http.post('/api/admin/GetBannerDetails', data).subscribe((res: any) => {
      if (res.data.length > 0) {
        this.Banner = Object.assign({}, res.data[0]);
        this.displayedImage = res.data[0].displayedImage;

      } else {
        this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: { id: 0 } });

      }
    })
  }

}

